import { Link } from "react-router-dom";
import { usePlayer } from "../context/PlayerContext";
import { mediaUrl } from "../lib/api";
import { fmtDate } from "../lib/utils2";
import { Play, Lock, Clock } from "lucide-react";

export const EpisodeCard = ({ ep }) => {
  const { play } = usePlayer();
  return (
    <div data-testid={`episode-card-${ep.id}`} className="group bg-white border border-slate-100 rounded-xl overflow-hidden hover:-translate-y-2 transition-transform duration-300 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)]">
      <div className="relative aspect-video overflow-hidden">
        <img src={mediaUrl(ep.cover_url)} alt={ep.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy/60 to-transparent" />
        <button onClick={() => play(ep)} data-testid={`play-${ep.id}`} className="absolute bottom-3 left-3 w-12 h-12 rounded-full bg-white/95 flex items-center justify-center shadow-lg hover:bg-gold transition-colors">
          <Play className="w-5 h-5 text-navy ml-0.5" />
        </button>
        {ep.is_premium && (
          <span className="absolute top-3 right-3 flex items-center gap-1 bg-gold/95 text-navy text-xs font-bold px-2.5 py-1 rounded-full">
            <Lock className="w-3 h-3" /> Premium
          </span>
        )}
      </div>
      <div className="p-5">
        <div className="flex items-center gap-2 text-xs text-slate-400 mb-2">
          <span className="font-semibold text-navy">{ep.category}</span>
          <span>•</span>
          <span>{fmtDate(ep.published_at)}</span>
          <span className="ml-auto flex items-center gap-1"><Clock className="w-3 h-3" />{ep.duration}</span>
        </div>
        <Link to={`/episodi/${ep.id}`}>
          <h3 className="font-serif text-lg font-semibold text-navy leading-snug mb-2 line-clamp-2 hover:text-petrol transition-colors">{ep.title}</h3>
        </Link>
        <p className="text-sm text-slate-500 line-clamp-2 mb-3">{ep.description}</p>
        <div className="flex flex-wrap gap-1.5">
          {ep.tags?.slice(0, 3).map((t) => (
            <span key={t} className="bg-slate-100 text-slate-600 text-xs font-semibold px-2.5 py-1 rounded-full">#{t}</span>
          ))}
        </div>
      </div>
    </div>
  );
};
